import { createStore } from 'effector';

import { User } from 'models/User/User';

import { initialUser } from './constants';

export const $user = createStore<User>(initialUser);
